import { PropsWithChildren } from 'react';
import { FlexBox, responsive } from '@vp/swan';

const ResponsiveFlexBox = responsive(FlexBox);

export default function StepTitleContainer({
    children,
    isModal,
}: PropsWithChildren & { isModal: boolean }) {
    return (
        <ResponsiveFlexBox
            style={{
                alignSelf: isModal ? 'stretch' : 'flex-start',
            }}
            sm={{
                style: {
                    alignSelf: isModal ? 'stretch' : 'center',
                },
            }}
            md={{
                style: {
                    alignSelf: 'stretch',
                },
            }}
        >
            {children}
        </ResponsiveFlexBox>
    );
}
